<template>
  <div class="ticketPay">
    <div class="center">{{formData.carNo}}的罚单代缴办理</div>
    <div class="ticketPayInfo">
      <van-row justify="space-between">
        <van-col span="12" class="text">现场处罚决定书编号</van-col>
        <van-col span="12" class="textRight">{{formData.ticketNo}}</van-col>
        <van-col span="12" class="text">处罚日期</van-col>
        <van-col span="12" class="textRight">{{formData.ticketDate}}</van-col>
        <van-col span="12" class="text">处罚金额</van-col>
        <van-col span="12" class="textRight">¥{{formData.ticketAmount}}</van-col>
        <van-col span="12" class="text">滞纳金</van-col>
        <van-col span="12" class="textRight">¥{{formData.overdueAmount}}</van-col>
        <van-col span="12" class="text">服务费</van-col>
        <van-col span="12" class="textRight">¥{{formData.serviceAmount}}</van-col>
      </van-row>
    </div>
    <div class="charge-view-right">
      <right-selector-new
        v-model="selectedRights"
        :rightOptions="rightOptions"
        :keyAdapter="{rightCode: 'rightCode'}"
        @select="selectRightClick"
        :isShowDetail="isShowDetail"
        :rightDiscount="rightDiscount"
      />
    </div>
    <div class="bottom">
      <div>
        您需缴纳
        <span class="amount">¥{{totalAmount}}</span>
      </div>
      <van-button type="primary" color="#3399FF" @click="pay">去支付</van-button>
    </div>
  </div>
</template>
<script>
import { createOrder, carLifePayPre, getAllSimpleProductInfo, findValidRight, carLifeOrderDetail } from "@/common/api.js";
import Pay from "@/common/weixin.js";
import { debounce, cloneDeep } from "lodash";
import RightSelectorNew from '@/components/right-selector-new.vue';
import { CarLifeOrderStatus } from "@/common/constant.js";
export default {
  name: "ticketPay",
  components: {
    RightSelectorNew
  },
  data() {
    return {
      formData: {},
      orderNo: '',
      orderStatus: '',
      selectedRights: {},
      rightOptions: [],
      totalAmount: null,
      isShowDetail: true,
      rightDiscount: null
    }
  },
  watch: {
    selectedRights(val){
      if(val.rightDiscount){
        const {totalAmount} = this.formData
        const _rightDiscount = val.rightRuleList[0].rightType === '2' ? this.formData.totalAmount : Number(val.rightDiscount)
        // 权益金额 大于 处罚金额，展示处罚金额
        this.rightDiscount = _rightDiscount > totalAmount ? totalAmount : _rightDiscount
        this.totalAmount = (totalAmount - _rightDiscount).toFixed(2)
      } else{
        this.totalAmount = this.formData.totalAmount
        this.rightDiscount = 0
      }
      if(this.totalAmount < 0){
        this.totalAmount = 0
      }
    }
  },
  mounted() {
    this.formData = JSON.parse(this.$route.query.formData)
    this.formData.ticketAmount = this.formData.ticketAmount.toFixed(2)
    this.formData.overdueAmount = this.formData.overdueAmount.toFixed(2)
    this.formData.serviceAmount = this.formData.serviceAmount.toFixed(2)
    this.totalAmount = cloneDeep(this.formData.totalAmount)
    this.findValidRight()
    this.init()
  },
  methods: {
    init() {
      if (this.$route.query.orderNo) {
        let arr = this.$route.query.orderNo;
        if (Array.isArray(arr)) {
          this.orderNo = arr[arr.length - 1];
        } else {
          this.orderNo = this.$route.query.orderNo;
        }
      }
      if(this.$route.query.isCallBack){
        this.showConfirmDialog()
      }
    },
    showConfirmDialog() {
      this.$toast.loading({
        message: "支付结果检查中...",
        forbidClick: true,
        duration: 0,
      });
      this.checkPay();
      // this.prePaySuccess()
      // this.$toast.clear();
    },
    async checkPay() {
      try {
        let res = await carLifeOrderDetail({
          orderNo: this.orderNo,
        });
        this.$toast.clear();
        //待支付的，去订单详情
        if (res.rechargeStatus == CarLifeOrderStatus.unpaid) {
          this.prePayErr();
        } else {
          this.prePaySuccess();
        }
      } catch (error) {
        this.$toast.clear();
      }
    },
    //立即支付的
    pay: debounce(
      async function () {
        this.$toast.loading({
          message: "提交中",
          forbidClick: true,
          duration: 0,
        });
        try {
          const resp = await getAllSimpleProductInfo({productCode: this.$route.query.productCode})
          const formData = {
            contactPhone: this.formData.contactPhone,
            carNo: this.formData.carNo,
            ticketNo: this.formData.ticketNo,
            punishAmount: this.formData.ticketAmount,
            serviceAmount: this.formData.serviceAmount,
            overdueAmount: this.formData.overdueAmount,
            punishDate: this.formData.ticketDate,
            productSkuCode: resp.productStandardSkuRespVoList[0].productSkuCode,
            punishPoint: this.formData.point
          }
          let data = {}
          if(this.selectedRights.rightCode){
            const selectRights = {
              version: this.selectedRights ? this.selectedRights.version : '',
              rightCode: this.selectedRights ? this.selectedRights.rightCode : '',
              rightPackageCode: this.selectedRights ? this.selectedRights.rightPackageCode : '',
              rightRuleCode: this.selectedRights ? this.selectedRights.rightRuleList[0].rightRuleCode : '',
            }
            data = {...formData, ...selectRights}
          }else{
            data = formData
          }
          const res = await createOrder(data)
          this.orderNo = res.orderNo
          this.orderStatus = res.orderStatus
          if (res.needPay) {
            const envMap = ["1", "1", "4"];
            //调起预支付接口成功后
            let prepayRs = await carLifePayPre({
              payType: envMap[this.$browserEnv], //支付环境
              orderNo: this.orderNo,
            });
            this.prePayHandle(prepayRs);
          }else{
            this.prePaySuccess()
          }
        } catch (error) {}
        this.$toast.clear()
      },
      3000,
      { leading: true, trailing: false }
    ),
    prePayHandle(payload) {
      const _payload = {
        appId: payload.appId,
        timeStamp: payload.timeStamp,
        nonceStr: payload.nonceStr,
        package: payload.packageValue,
        signType: payload.signType,
        paySign: payload.paySign,
        prepayId: payload.prepayId,
        mwebUrl: payload.mwebUrl,
      };
      switch (this.$browserEnv) {
        case 0:
          Pay.mpPay(_payload, this.orderNo, 'ticket');
          break;
        case 1:
          Pay.wxPay(_payload, this.prePaySuccess, this.prePayErr);
          break;
        case 2:
          Pay.browserPay(_payload.mwebUrl, this.orderNo, 'ticket');
          break;
      }
    },
    prePaySuccess() {
      this.$router.replace({
        name: "resultPage",
        query: {
          orderNo: this.orderNo,
          orderStatus: CarLifeOrderStatus.success,
          orderType: "05",
          phone: this.$route.query.phone,
          categoryCode: this.$route.query.categoryCode,
        },
      });
      // this.$router.replace({
      //   path: "/ticketOrderDetail",
      //   query: {
      //     orderNo: this.orderNo,
      //   },
      // });
    },
    prePayErr() {
      this.$toast('支付失败')
      this.$router.replace({
        path: '/ticketOrderDetail',
        query: {
          orderNo: this.orderNo
        },
      });
    },
    selectRightClick(item) {
      this.selectedRights = item;
    },
    // 获取权益
    async findValidRight() {
      const data = {
        phone: this.$route.query.phone,
        productCode: this.$route.query.productCode,
      }
      const res = await findValidRight(data)
      this.rightOptions = res
      this.rightOptions && this.rightOptions.forEach((item) => {
          item.rightId = item.rightPackageCode + "-" + item.rightCode;
          item.timesLeft = item.validCount;
          // item.disabled = true; //都是禁用的
        });
    },
    async getAllSimpleProductInfo() {
      const res = await getAllSimpleProductInfo({productCode: this.$route.query.productCode})
      console.log(res, '-----');
      // this.productSkuCode = res.productStandardSkuRespVoList[0].productSkuCodes
    }
  }
}
</script>
<style scoped lang="scss">
.ticketPay{
  width: 100%;
  background: #F4F6F7;
  height: 100vh;
  font-size: 0.36rem;
  font-family:'Microsoft YaHei';
  .center{
    background: #fff;
    padding: 0 0.4rem;
    height: 1rem;
    line-height: 1rem;
    font-weight: 500;
    margin-bottom: 0.03rem;
    border-top: 0.3rem solid #F4F6F7;
    span{
      margin-right: 0.2rem;
      font-family: PingFangSC-Medium;
      color: #383838;
      font-size: 0.3rem;
    }
  }
  .ticketPayInfo{
    background: #fff;
    padding: 0 0.4rem;
    font-size: 0.3rem;
    color: #787878;
    
    .textRight{
      text-align: right;
      color: #383838;
      height: 0.8rem;
      line-height: 0.8rem;
    }
    .text{
      height: 0.8rem;
      line-height: 0.8rem;
    }
  }
  .cell{
    padding-top: 0.3rem;
  }
  .bottom{
    width: 100%;
    position: fixed;
    bottom: 0;
    height: 1.2rem;
    line-height: 1.2rem;
    background: #fff;
    font-size: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.4rem;
    box-sizing: border-box;
    /deep/ .van-button{
      width: 2.8rem;
      height: 0.96rem;
      border-radius: 0.16rem;
    }
    .amount{
      color: #EA3F26;
    }
  }
}

</style>